import { Paginated } from "src/@types/paginated";
import { Tags } from "@/enum/tags";
import { apiSlice } from "../../http";
import { IQueryParams } from "@/@types/query";
import { IQueryConnection } from "@/@types/query-connections";

export const QueryConnectionsInformations = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getConnections: builder.query<Paginated<IQueryConnection>, IQueryParams>({
      query: ({ search, meta, orderBy, perPage }) => {
        const params = new URLSearchParams({
          search,
          orderBy,
          page: meta.page.toString(),
          perPage: perPage.toString(),
        });

        return {
          url: `/query-updates/connections?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.QUERY_CONNECTIONS],
    }),
    createConnection: builder.mutation<string, IQueryConnection>({
      query: (data: IQueryConnection) => ({
        url: `/query-updates/connections`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [Tags.QUERY_CONNECTIONS],
    }),
    updateConnection: builder.mutation<string, IQueryConnection>({
      query: (data: IQueryConnection) => ({
        url: `/query-updates/connections`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: [Tags.QUERY_CONNECTIONS],
    }),
    deleteConnection: builder.mutation<any, { id: number }>({
      query: ({ id }) => {
        return {
          url: `/query-updates/connections/`,
          method: "DELETE",
          body: { id },
        };
      },
      invalidatesTags: [Tags.QUERY_CONNECTIONS],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetConnectionsQuery,
  useCreateConnectionMutation,
  useDeleteConnectionMutation,
  useUpdateConnectionMutation,
} = QueryConnectionsInformations;
